<template lang="html">


  <div class="wrapper margin-menu">

    <section class="intro column-center -emprendimiento">
      <h2>Emprendimiento</h2>
      <h1>El proyecto</h1>
    </section>

    <section class="breadcrumb">
      <nav class="container row-end">
        <router-link to="/">Inicio</router-link>
        <router-link :to="$t('enlaces.lafundacion')">La Fundación</router-link>
        <router-link :to="$t('enlaces.emprendimiento')">El proyecto</router-link>
      </nav>
    </section>

    <main>

      <div class="container">

        <h2 class="title-intro">
          Fomentamos el <strong>emprendimiento</strong>
        </h2>

        <p class="texto-intro">
          Desde la Fundación entendemos el emprendimiento como un elemento fundamental para el desarrollo económico de cualquier sociedad. El apoyo a los emprendedores para que creen empresas y generen empleo se constituye en el objetivo primordial de este área de intervención de la Fundación.
        </p>

      </div>


      <div class="white-box">
        <div class="container row-start">
          <h2 class="big-title">Proyectos</h2>
        </div>
        <div class="title-container row-end">
          <!-- <h3 class="title-destacado">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Praesentium, natus velit?</h3> -->
        </div>
      </div>







      <div class="cuerpos-descargas container row-between -proyectos">

        <div class="cuerpo-descarga">
          <div class="contenedor-imagen">
          <img src="/static/img/logo-mide.png" alt="Logo mide">
        </div>
          <p>La asociación MIDE pretende conectar entidades y unificar esfuerzos para mejorar la posición competitiva de la Comunidad de Madrid y contribuir al desarrollo de su ecosistema de emprendimiento.</p>
          <router-link :to="$t('enlaces.mide')" class="btn with-border">Ver proyecto</router-link>
        </div>

        <div class="cuerpo-descarga">
          <div class="contenedor-imagen row-center">
          <img src="/static/img/logo-patio.svg" alt="Logo patio">
        </div>
          <p>Un espacio neutral que nace con el objetivo de convertirse en el punto de encuentro del ecosistema innovador, conectando corporaciones, emprendedores, administración pública y todos aquellos agentes necesarios para que la innovación ocurra.</p>
          <router-link :to="$t('enlaces.patio')" class="btn with-border">Ver proyecto</router-link>
        </div>

      </div>


    </main>

  </div>

</template>

<script lang="js">
  
  
  export default {
    name: 'emprendimiento',
  }
    
  </script>


<style lang="scss">
  
  </style>


// WEBPACK FOOTER //
// src/components/views/emprendimiento.vue